<template lang="pug">
include ../../../../prototype/src/pug/abstracts/variables
include ../../../../prototype/src/pug/abstracts/mixin.pug
mixin navigation_item(label, link, active = false) 
	if active
		.navigation__item(ref=link, onclick="hamburger.hide();").active
			a(href="#" + link)= label
			block
	else
		.navigation__item(ref=link, onclick="hamburger.hide();")
			a(href="#" + link)= label
			block

header.navigation__wrapper#top_navigation(v-hamburger-container)
	nav.navigation__inner
		.navigation__logo
			a(href="/")
				+i('logo-spcbrasil.png')
			button.hamburger.hamburger--spin(type="button", v-hamburger-toggler)
				span.hamburger-box
					span.hamburger-inner
		.navigation__items
			NavigationItem(label="Benefícios", id="beneficios", navigationToken="beneficios", @toggleMenu="turnOffSubMenuSuporte", :isActive="!$router.currentRoute.path.includes('repositorio') && !$router.currentRoute.path.includes('suporte')")
			NavigationItem(label="Certificados", id="certificados", navigationToken="certificados", @toggleMenu="turnOffSubMenuSuporte")
			a.navigation__item(:class="{ active: $router.currentRoute.path.includes('suporte') }" :href="BASE_URL + '#precisa_de_ajuda'" @click="toggleSubMenuSuporte", token="suporte", v-scroll-top-navigation="{container: 'suporte, instalacao, instalacao_detalhe, precisa_de_ajuda, faq, atendimento'}", v-hamburger-link)
				|Suporte
				.navigation__submenu('v-if'="isShowSubmenuSuporte")
					a(:href="BASE_URL + 'suporte/instalacao'") Instalação
					a(:href="BASE_URL + 'suporte/duvidas-frequentes'") Dúvidas frequentes
					a(href="https://spc.xgen.com.br/spc/form_chat_cliente.html") Atendimento
					a(:href="BASE_URL + 'suporte/revogacao'") Revogação
			NavigationItem(label="Postos de Atendimento", id="posto_de_atendimento", navigationToken="posto_de_atendimento", @toggleMenu="turnOffSubMenuSuporte")
			<div class="navigation__item" v-bind:class="{ active: $router.currentRoute.path.includes('repositorio') }">
				<a :href="BASE_URL + 'repositorio'">Repositório</a>
			</div>
			
			SearchComponent(:term="this.initial_term_value")
</template>

<script>
import SearchComponent from "@/components/busca/SearchComponent.vue";
import NavigationItem from "@/components/navigation/NavigationItem.vue";
import NavigationRoute from "@/components/navigation/NavigationRoute.vue";

export default {
	name: "Navigation",
	components: {
		NavigationItem,
		NavigationRoute,
		SearchComponent,
	},
	data: function () {
		return {
			isShowSubmenuSuporte: false,
			BASE_URL: process.env.BASE_URL,
		};
	},
	methods: {
		toggleSubMenuSuporte: function () {
			this.isShowSubmenuSuporte = !this.isShowSubmenuSuporte;
		},
		turnOffSubMenuSuporte: function () {
			this.isShowSubmenuSuporte = false;
		},
	},
	computed: {
		initial_term_value: function () {
			if (this.$route.params) {
				if (this.$route.params.term) {
					return this.$route.params.term;
				}
			}

			return "";
		},
	},
};
</script>
